module.exports = __webpack_public_path__ + "static/media/entranceP.dc228c9b.jpg";